import React, { useEffect, useState } from "react";
import Layout from "src/components/layout/website/Layout";
import Form, { FormField } from "src/components/ui/Form";
import Alert from "src/components/ui/Alert";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as supportRequestActions from "src/redux/slices/supportRequestSlice";

const ContactPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const { create } = useAppSelector((state) => state.supportRequest);
  const [formKey, setFormKey] = useState(0);

  useEffect(() => {
    if (create.data) {
      setFormKey((prev) => prev + 1);
      setTimeout(() => {
        dispatch(supportRequestActions.resetCreateSupportRequest());
      }, 5000);
    } else if (create.error) {
      // toast.error(`Error: ${create.error}`);
      // dispatch(supportRequestActions.resetSupportRequestCreate());
    }
  }, [create, dispatch]);

  const fields: FormField[] = [
    {
      label: "Full Name",
      name: "name",
      type: "text",
      placeholder: "Your full name",
      validations: { required: true },
    },
    {
      label: "Mobile Number",
      name: "mobile",
      type: "number",
      placeholder: "Your mobile number",
      validations: {
        required: true,
        max: 10,
        regex: "^[0-9]{10}$",
        message: "Enter a valid 10-digit number",
      },
    },
    {
      label: "Email Address",
      name: "email",
      type: "email",
      placeholder: "Your email address",
      validations: { required: true },
    },
    {
      label: "Message",
      name: "message",
      type: "textarea",
      placeholder: "Your message",
      validations: { required: true },
    },
  ];

  const handleSubmit = (values: Record<string, any>) => {
    dispatch(
      supportRequestActions.createSupportRequestRequest({
        name: values.name?.trim(),
        email: values.email?.trim(),
        mobile: values.mobile?.trim(),
        message: values.message?.trim(),
      })
    );
  };

  return (
    <Layout>
      <div className="min-h-screen bg-white py-20 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl font-bold text-indigo-600 mb-8">
            Contact Us
          </h1>
          <p className="text-gray-600 mb-12">
            Have questions or want a demo? Drop your details and we’ll connect
            shortly.
          </p>

          {create.data?.requestId && (
            <div className="mb-4">
              <Alert
                type="success"
                message={`Your support request has been submitted successfully. Request ID: ${create.data?.requestId}`}
              />
            </div>
          )}

          {create.error && (
            <div className="mb-4">
              <Alert type="error" message={create.error} />
            </div>
          )}

          <Form
            key={formKey}
            fields={fields}
            onSubmit={handleSubmit}
            submitLabel="Send Message"
            loading={create.loading}
          />
        </div>
      </div>
    </Layout>
  );
};

export default ContactPage;
